module.exports = __webpack_public_path__ + "static/media/breadcrumb.effd2f97.less";